import { ExportOutlined, LeftOutlined } from "@ant-design/icons";
import { IoPersonAddOutline } from "react-icons/io5";
import { MdCall, MdExitToApp, MdLabelOutline } from "react-icons/md";
import { VscLayoutSidebarRight } from "react-icons/vsc";

import { Drawer, Menu, Select, Tooltip } from "antd";
import { BsArrowClockwise } from "react-icons/bs";
import { FaTrash, FaVideo } from "react-icons/fa6";
import { GoSearch } from "react-icons/go";
import { HiMiniUserGroup } from "react-icons/hi2";
import {
  conversationStatus,
  conversationType,
  role,
} from "../../config/Constant";
import { useChatContext } from "../../context/ChatContext";
import { useMenuContext } from "../../context/MenuContext";
import { useInfoUser } from "../../store/UserStore";
import "./style.scss";

const SideBarConversation = ({
  isOpen,
  onClose,
  isExitGroup,
  onCall,
  onRefresh,
  onToggleGroupInfo,
}) => {
  const { labelList } = useMenuContext();
  const { languageMap } = useInfoUser();
  const {
    onSearch,
    onChangeLabel,
    refreshChatMessage,
    setIsMenu,
    showModalLabel,
    labelSelectedId,
    selectedConversation,
  } = useMenuContext();

  const { openModalConfirm, openAddMemberModal, setIsEnableGroup } =
    useChatContext();

  const runAction = (action) => {
    onClose();
    action?.();
  };

  return (
    <Drawer
      placement={"right"}
      closable={false}
      onClose={onClose}
      open={isOpen}
      width={330}
      className="drawer-visible"
      title={
        <div className="flex flex-row">
          <span className="drawer-label">
            <a
              onClick={() => {
                setIsMenu(false);
              }}
            >
              <LeftOutlined className="drawer-btn-close" />
            </a>
            {languageMap?.["modal.menu"] ?? "Menu"}
          </span>
        </div>
      }
    >
      <Menu
        mode="inline"
        width={330}
        // inlineCollapsed={false}
        className="py-4 overflow-y-auto space-y-2 font-medium"
        selectable={false}
      >
        {selectedConversation?.type !== conversationType.SELF && (
          <>
            <Menu.Item
              key="audioCall"
              className="cursor-pointer"
              onClick={() => runAction(() => onCall("audio"))}
            >
              <div className="drawer-item">
                <div className="drawer-item-icon">
                  <MdCall size={20} color="black" />
                </div>
                <div className="ms-3">
                  <span>
                    {languageMap?.["menu.conversation.audioCall"] ??
                      "Audio call"}
                  </span>
                </div>
              </div>
            </Menu.Item>
            <Menu.Item
              key="videoCall"
              className="cursor-pointer"
              onClick={() => runAction(() => onCall("video"))}
            >
              <div className="drawer-item">
                <div className="drawer-item-icon">
                  <FaVideo size={20} color="black" />
                </div>
                <div className="ms-3">
                  <span>
                    {languageMap?.["menu.conversation.videoCall"] ??
                      "Video call"}
                  </span>
                </div>
              </div>
            </Menu.Item>
          </>
        )}

        {selectedConversation?.role !== role.MEMBER &&
          selectedConversation?.conversationStatus ===
            conversationStatus.ACTIVE &&
          ![conversationType.PERSONAL, conversationType.SELF].includes(
            selectedConversation?.type,
          ) && (
            <Menu.Item
              key="addMember"
              className="cursor-pointer"
              onClick={() => runAction(openAddMemberModal)}
            >
              <div className="drawer-item">
                <div className="drawer-item-icon">
                  <IoPersonAddOutline size={20} color="black" />
                </div>
                <div className="ms-3">
                  <span>
                    {languageMap?.["menu.conversation.addMember"] ??
                      "Add more members"}
                  </span>
                </div>
              </div>
            </Menu.Item>
          )}
        <Menu.Item
          key="search"
          className="cursor-pointer"
          onClick={() => runAction(onSearch)}
        >
          <div className="drawer-item">
            <div className="drawer-item-icon">
              <GoSearch size={20} color="black" />
            </div>
            <div className="ms-3">
              <span>
                {languageMap?.["menu.conversation.searchMessage"] ??
                  "Search messages"}
              </span>
            </div>
          </div>
        </Menu.Item>
        <Menu.Item
          key="refresh"
          className="cursor-pointer"
          onClick={() => runAction(onRefresh || refreshChatMessage)}
        >
          <div className="drawer-item">
            <div className="drawer-item-icon">
              <BsArrowClockwise size={20} color="black" />
            </div>
            <div className="ms-3">
              <span>
                {languageMap?.["menu.conversation.refresh"] ?? "Refresh"}
              </span>
            </div>
          </div>
        </Menu.Item>
        {selectedConversation &&
          ![conversationType.PERSONAL, conversationType.SYSTEM].includes(
            selectedConversation?.type,
          ) && (
            <>
              {isExitGroup && (
                <Menu.Item
                  key="exit"
                  className="cursor-pointer"
                  onClick={() => runAction(openModalConfirm)}
                >
                  <div className="drawer-item">
                    <div className="drawer-item-icon">
                      <MdExitToApp size={20} color="black" />
                    </div>
                    <div className="ms-3">
                      <span>
                        {languageMap?.["menu.conversation.exitGroup"] ??
                          "Exit group"}
                      </span>
                    </div>
                  </div>
                </Menu.Item>
              )}

              {selectedConversation?.conversationStatus ===
                conversationStatus.ACTIVE &&
                !isExitGroup && (
                  <Menu.Item
                    key="delete"
                    className="cursor-pointer"
                    onClick={() => runAction(openModalConfirm)}
                  >
                    <div className="drawer-item">
                      <div className="drawer-item-icon">
                        <FaTrash size={20} color="black" />
                      </div>
                      <div className="ms-3">
                        <span>
                          {languageMap?.["menu.conversation.disableGroup"] ??
                            "Disable group"}
                        </span>
                      </div>
                    </div>
                  </Menu.Item>
                )}

              {selectedConversation?.conversationStatus ===
                conversationStatus.INACTIVE &&
                !isExitGroup && (
                  <Menu.Item
                    key="enable"
                    className="cursor-pointer"
                    onClick={() =>
                      runAction(() => {
                        setIsEnableGroup(true);
                        openModalConfirm();
                      })
                    }
                  >
                    <div className="drawer-item">
                      <div className="drawer-item-icon">
                        <HiMiniUserGroup size={20} color="black" />
                      </div>
                      <div className="ms-3">
                        <span>
                          {languageMap?.["menu.conversation.enableGroup"] ??
                            "Enable group"}
                        </span>
                      </div>
                    </div>
                  </Menu.Item>
                )}
            </>
          )}
        <Menu.Item
          key="groupInfo"
          className="cursor-pointer"
          onClick={() => runAction(onToggleGroupInfo)}
        >
          <div className="drawer-item">
            <div className="drawer-item-icon">
              <VscLayoutSidebarRight size={20} color="black" />
            </div>
            <div className="ms-3">
              <span>
                {languageMap?.["menu.conversation.groupInfo"] ??
                  "Group information"}
              </span>
            </div>
          </div>
        </Menu.Item>
      </Menu>
    </Drawer>
  );
};

export { SideBarConversation };
